import { Card, CardContent, makeStyles, Grid, Button, Divider, Link, Typography, IconButton } from "@material-ui/core";
import { Dialog, DialogContent, DialogActions, DialogTitle } from "@material-ui/core";
import React, { useEffect, useState } from 'react'
import EApplicantDetailsControl from './e_applicant-details/e_applicant-details-controller'
import EHeader from "./view/e_header";
import EStepper from './view/e_stepper';
import E_PremiseDetails from "./e_premise-details/e_communication-address-details"
import { useSelector } from "react-redux";
import { adminService } from "../../services";
import { routePaths } from "../config/route-paths";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import Close from "@material-ui/icons/Close"
import { history, store } from "../../helpers";
import EFooterSection from "../e_home-page/e_footer-section/e_footer-section";
import EUplaodDocuments from "./e_upload-documents/e_docuement-upload";
import EConfirmation from "./e_confirmation-screen/e_confirmation";
import ESummaryReview from "./e_summary-review/e_summary-review";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { ticketService } from './model/_service'

const useStyles = makeStyles((theme) => ({
  cardStyle: {
    minHeight: "95vh"
  },
  contentBg: {
    background: theme?.palette?.eLight?.base + " !important",
    padding: "1.5rem 1.5rem 0rem !important",
    paddingBottom: 0,
    [theme.breakpoints.down("xs")]: {
      padding: "0px !important",
      paddingBottom: "8%"
    },
  },
  divider: {
    marginTop: "9rem",
    marginBottom: "1rem",
    [theme.breakpoints.down("xs")]: {
      marginTop: "1rem"
    },
  },
  container: {
    justifyContent: "right",
    align: "right"
  },
  cancel: {
    color: theme.palette.ePrimary.base,
    marginTop: "0.25rem",
  },
  submit: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    '&:hover': {
      backgroundColor: theme.palette.ePastelColor2.base,
    },
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "3rem"
  },
  disable: {
    backgroundColor: theme.palette.eLight.base,
    color: theme.palette.eRich.base,
    borderRadius: 30,
    padding: "3% 25%",
    marginLeft: "1rem",
    marginRight: "5rem"
  },
  closeIcon: {
    color: theme.palette.eWhite.base,
  },
  rightIcon: {
    textAlign: "-webkit-right",
  },
  contentColor: {
    background: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    paddingLeft: "5%",
  },
  alertIcon: {
    color: theme?.palette?.eTertiary?.base,
    width: "4rem",
    height: "auto",
    display: "block",
    margin: "1rem auto",
  },
  yes: {
    backgroundColor: theme.palette.ePrimary.base,
    color: theme.palette.eWhite.base,
    borderRadius: 30,
    "&:hover": {
      backgroundColor: theme.palette.ePrimary.hover,
    },
    padding: "3% 35%",
  },
  no: {
    color: theme.palette.ePrimary.base,
  },
  dialoagActionPadding: {
    paddingTop: "0.938rem",
    paddingBottom: "0.938rem",
  },
  dialogTextPadding: {
    padding: "0rem 1.875rem 1.875rem",
    textAlign: "center"
  },
  cardCont: {
    minHeight: "inherit"
  },
  mainContentHeight: {
    minHeight: "65vh"
  },
  dialogContainerStyling: {
    "& .MuiDialog-paperWidthSm": {
      [theme.breakpoints.up("sm")]: {
        minWidth: "25rem !important"
      },
      [theme.breakpoints.down("sm")]: {
        minWidth: "20rem !important"
      },
    }
  }
}))

function ENewConnectionRequest() {
  const classes = useStyles()
  const summaryReviewLabel = useSelector((state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW);
  const languageCode = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const primaryLanguage = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE);
  const mobileLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.MOBILE_LENGTH);
  const zipLength = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_LENGTH);
  const zipLengthError = useSelector((store) => store?.parametersWidgets?.ParameterLookup?.ZIPCODE_MIN_LENGTH);
  const customerNumberLength = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_CUSTOMER_NO_LENGTH);
  const [activeStep, setActiveStep] = useState(0)
  const [existingCustomer, setexistingCustomer] = useState("no");
  const [existingCustomerID, setexistingCustomerID] = useState("");
  const [existingPremisesList, setexistingPremisesList] = useState([]);

  const [name, setName] = useState("");
  const [openMobileDialog, setOpenMobileDialog] = useState(true);
  const [fatherName, setFatherName] = useState("");
  const [husbandName, setHusbandName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [idType, setIdType] = useState("Bangladesh National Identification Number");
  const [idTypeCode, setIdTypeCode] = useState("CM_NID");
  const [tinTypeCode, setTinTypeCode] = useState("CM_TIN");
  const [idTypeOthers, setIdTypeOthers] = useState("");
  const [idValue, setIdValue] = useState("");
  const [tinValue, setTinValue] = useState("");
  const [individualVerifiedMobile, setIndividualVerifiedMobile] = useState([]);
  const [dropDownData, setDropDownData] = useState([]);
  const [husbandWifeRadio, sethusbandWifeRadio] = useState("husband");
  const [connectionType, setconnectionType] = useState("")
  const [connectionTypeCode, setConnectionTypeCode] = useState("");
  const [tarrifType, setTarrifType] = useState("");
  const [tarrifTypeCode, setTarrifTypeCode] = useState("");
  const [Load, setLoad] = useState("");
  const [meterType, setMeterType] = useState("")
  const [meterTypeCode, setMeterTypeCode] = useState("")
  const [thanadropdown, setthanadropdown] = useState("");
  const [districtdropdown, setdistrictdropdown] = useState("");
  const [isIndividualMobileVerified, setIsIndividualMobileVerified] = useState(false);
  const [open, setOpen] = useState(false);
  const [sameAsPremiseCheck, setSameAsPremiseCheck] = useState(false);
  const [checkBoxEnable, isCheckBoxEnable] = useState(false);
  const [divisionList, setdivisionList] = useState([])
  const [districtPremise, setDistrictPremise] = useState("");
  const [address1Premise, setAddress1Premise] = useState("");
  const [address2Premise, setAddress2Premise] = useState("");
  const [postOfficePremise, setPostOfficePremise] = useState("");
  const [divisionPremise, setDivisionPremise] = useState("");
  const [divisionCodePremise, setDivisionCodePremise] = useState("");
  const [postCodePremise, setPostCodePremise] = useState("");
  const [thanaPremise, setThanaPremise] = useState("");
  const [districtMailing, setDistrictMailing] = useState("");
  const [address1Mailing, setAddress1Mailing] = useState("");
  const [address2Mailing, setAddress2Mailing] = useState("");
  const [postOfficeMailing, setPostOfficeMailing] = useState("");
  const [divisionMailing, setDivisionMailing] = useState("");
  const [divisionCodeMailing, setDivisionCodeMailing] = useState("");
  const [postCodeMailing, setPostCodeMailing] = useState("");
  const [thanaMailing, setThanaMailing] = useState("");
  const [showConnectionOnExistingPremise, setshowConnectionOnExistingPremise] = useState()
  const [connectionOnExistingPremise, setconnectionOnExistingPremise] = useState("no");
  const [premiseType, setpremiseType] = useState("");
  const [premiseTypeCode, setpremiseTypeCode] = useState("");
  const [premiseCategory, setpremiseCategory] = useState("");
  const [premiseCategoryCode, setpremiseCategoryCode] = useState("");
  const [sndCode, setSndCode] = useState("");
  const [sndValue, setSndValue] = useState("");
  const [noofconnections,setnoofconnections]=useState("1");

  const [existingPremiseID, setexistingPremiseID] = useState("");
  const [existingPremiseValue, setexistingPremiseValue] = useState("");

  const [termsAgreedTime, setTermsAgreedTime] = useState("")
  const [documentList, setDocumentList] = useState([]);
  const [documentCodeList, setDocumentCodeList] = useState([]);
  const [ticketNumber, setTicketNumber] = useState("");
  const [applicationDate, setApplicationDate] = useState();
  const [MasterDataDetailsError,setMasterDataDetailsError]=useState("");
  const [existingCustomerNotValid, setexistingCustimerNotValid] = useState(false)
  const [masterDataEmail,setmasterDataEmail]=useState("")
  const [masterDataName,setmasterDataName]=useState("")
  const [masterDataIdValue,setmasterDataIdValue]=useState("")
  const [masterDataTinValue,setmasterDataTinValue]=useState("")
  const [masterDataFatherName,setmasterDataFatherName]=useState("")
  const [masterDataMotherName,setmasterDataMotherName]=useState("")
  const [masterDataAddress1Mailing,setmasterDataAddress1Mailing]=useState("")
  const [masterDataAddress2Mailing,setmasterDataAddress2Mailing]=useState("")
  const [masterDataPostOfficeMailing,setmasterDataPostOfficeMailing]=useState("")
  const [masterDataPostCodeMailing,setmasterDataPostCodeMailing]=useState("")
  const [masterDataDistrictMailing,setmasterDataDistrictMailing]=useState("")
  const [masterDataDivisionCodeMailing,setmasterDataDivisionCodeMailing]=useState("")
  const [masterDataDivisionMailing,setmasterDataDivisionMailing]=useState("")
  const [masterDataThanaMailing,setmasterDataThanaMailing]=useState("")
  const [masterDataHusbandName,setmasterDataHusbandName]=useState("")
  const [masterDatahusbandWifeRadio,setmasterDatahusbandWifeRadio]=useState("")
  const [userEnteredMobileNumber,setuserEnteredMobileNumber]=useState("")
  const resetMailing = () => {
    setDistrictMailing("");
    setAddress1Mailing("");
    setAddress2Mailing("");
    setPostOfficeMailing("");
    setDivisionMailing("");
    setPostCodeMailing("");
    setThanaMailing("");
    setDistrictMailing("")
  }

  useEffect(() => {
    setconnectionOnExistingPremise("no")
    setexistingPremiseValue("")
    setAddress1Premise("")
    setAddress2Premise("")
    setThanaPremise("")
    setDistrictPremise("")
    setDistrictPremise("")
    setPostOfficePremise("")
    setDivisionPremise("")
    setPostCodePremise("")
    if(existingCustomer == "no"){
      setshowConnectionOnExistingPremise(false);
    } else {
      setshowConnectionOnExistingPremise(true);
    }
  }, [existingCustomer])
  

  useEffect(() => {
    if (sameAsPremiseCheck) {
      setSameAsPremiseCheck(false)
      resetMailing()
      if ( address1Premise && divisionPremise && districtPremise&&
         postCodePremise && postCodePremise.length >= parseInt(zipLengthError)) {
        isCheckBoxEnable(true);
      } else {
        isCheckBoxEnable(false);
      }
    } else if ( address1Premise && divisionPremise&& districtPremise && postCodePremise && postCodePremise.length >= parseInt(zipLengthError)) {
      isCheckBoxEnable(true);
    } else {
      isCheckBoxEnable(false);
    }
  }, [ address1Premise, address2Premise, postOfficePremise,districtPremise, divisionPremise, postCodePremise, thanaPremise]);

  useEffect(() => {
    if (isIndividualMobileVerified == true && !individualVerifiedMobile.includes(mobile)) {
      setIndividualVerifiedMobile([...individualVerifiedMobile, mobile])
    }
  }, [isIndividualMobileVerified])

  useEffect(() => {
    if (mobile.length != Number(mobileLength)) {
      setIsIndividualMobileVerified(false)
    } else if (mobile.length == Number(mobileLength)) {
      if (individualVerifiedMobile.includes(mobile)) {
        setIsIndividualMobileVerified(true)
      } else {
        setIsIndividualMobileVerified(false)
      }
    }
  }, [mobile])
  const {t:content, ready: contentReady} = useTranslation("content-E_SUMMARY_REVIEW");

  const handleBeforeUnload = (e) => {
    e.preventDefault()
    e.returnValue = '';
  }

  useEffect(() => {
    if (name != '' || fatherName != '' || husbandName != '' || motherName != '' || email != '' || mobile != '' || idType != '' || idValue != '' || tinValue != '' || connectionType != '' || tarrifType != '' || Load != '' || meterType != '' || existingCustomer!='' || existingCustomerID!='') {
      window.addEventListener("beforeunload", handleBeforeUnload, { capture: true });
    }
    else {
      window.removeEventListener("beforeunload", handleBeforeUnload, { capture: true });
    }
    return () => window.removeEventListener("beforeunload", handleBeforeUnload, { capture: true })
  }, [name, fatherName, husbandName, motherName, email, mobile, idType, idValue,tinValue, connectionType, tarrifType, Load, meterType,existingCustomer,existingCustomerID])


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const backCall = () => {
    history.push(routePaths?.LOGIN);
  };
  let RAJS="RAJS";
  let RAJSHAHI="Rajshahi";
  let RANGPUR="Rangpur";
  const getDetails=()=>{
    if(existingCustomerID.length==customerNumberLength){
      ticketService.getMasterDataDetails(existingCustomerID).then((res)=>{
        if(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]){
          setmasterDataEmail(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.email)	
          setmasterDataName(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.name)	
          setuserEnteredMobileNumber(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.phone?.slice(3,res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"].phone.length))	
          setmasterDataIdValue(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.Nid)
          setmasterDataTinValue(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.tinNo)
          setmasterDataFatherName(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.fatherName)
          setmasterDataMotherName(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.motherName)
          setmasterDataAddress1Mailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.address1)
          setmasterDataAddress2Mailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.address2)
          setmasterDataPostCodeMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.postal)
          setmasterDataPostOfficeMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.postoffice)
          if(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.division){
            let divisionResValue= res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.division===RAJS ? RAJSHAHI : RANGPUR
            setmasterDataDivisionMailing(divisionResValue)
            setmasterDataDistrictMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.district);
            setmasterDataDivisionCodeMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.division);
            setmasterDataThanaMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.thana);
          }
           if (res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.division && res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.district){
            setmasterDataDistrictMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.district);
            // setthanadropdown(districtList?.find(item => item?.dropDownValue === res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.district)?.dropDownCode)
            setmasterDataThanaMailing(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.thana);
           }
      if(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.husbandName){
        setmasterDataHusbandName(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.husbandName);
      setmasterDatahusbandWifeRadio("husband")
      // setspouseapiValue(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.husbandName);
      // setradiobutton("husband")
    }
      else{
        setmasterDataHusbandName(res?.data?.getMasterAmendmentPersonDetails["CM-ADMSTDATA"]?.wifeName);
        setmasterDatahusbandWifeRadio("wife")
      }
        }
        else{
          setMasterDataDetailsError(res?.data?.getMasterAmendmentPersonDetails.error)
        }
      },(err)=>{
        throw err
      }) 
    }else{
      setexistingCustimerNotValid(true)
    }
   
  }
  const getPage = () => {
    switch (activeStep) {
      case 0:
        return (
          <EApplicantDetailsControl
          noofconnections={noofconnections}
          setnoofconnections={setnoofconnections}
            name={name}
            setName={setName}
            fatherName={fatherName}
            setFatherName={setFatherName}
            husbandName={husbandName}
            setHusbandName={setHusbandName}
            motherName={motherName}
            setMotherName={setMotherName}
            email={email}
            setEmail={setEmail}
            openMobileDialog={openMobileDialog}
            setOpenMobileDialog={setOpenMobileDialog}
            mobile={mobile}
            setMobile={setMobile}
            idType={idType}
            setIdType={setIdType}
            setIdTypeCode={setIdTypeCode}
            tinTypeCode={tinTypeCode}
            setTinTypeCode={setTinTypeCode}
            idValue={idValue}
            setIdValue={setIdValue}
            setTinValue={setTinValue}
            tinValue={tinValue}
            setDropDownData={setDropDownData}
            dropDownData={dropDownData}
            individualVerifiedMobile={individualVerifiedMobile}
            setIndividualVerifiedMobile={setIndividualVerifiedMobile}
            tarrifType={tarrifType}
            setTarrifType={setTarrifType}
            setTarrifTypeCode={setTarrifTypeCode}
            Load={Load}
            setLoad={setLoad}
            meterType={meterType}
            setMeterType={setMeterType}
            setMeterTypeCode={setMeterTypeCode}
            idTypeOthers={idTypeOthers}
            setIdTypeOthers={setIdTypeOthers}
            isIndividualMobileVerified={isIndividualMobileVerified}
            setActiveStep={setActiveStep}
            setIsIndividualMobileVerified={setIsIndividualMobileVerified}
            existingCustomer={existingCustomer}
            setexistingCustomer={setexistingCustomer}
            existingCustomerID={existingCustomerID}
            setexistingCustomerID={setexistingCustomerID}
            connectionType={connectionType}
            setconnectionType={setconnectionType}
            setConnectionTypeCode={setConnectionTypeCode}
            setDocumentList={setDocumentList}
            setDocumentCodeList={setDocumentCodeList}
            setexistingPremisesList={setexistingPremisesList}
            husbandWifeRadio={husbandWifeRadio}
            sethusbandWifeRadio={sethusbandWifeRadio}
            idTypeCode={idTypeCode}
            getDetails={getDetails}
            MasterDataDetailsError={MasterDataDetailsError}
            setMasterDataDetailsError={setMasterDataDetailsError}
            setexistingCustimerNotValid={setexistingCustimerNotValid}
            existingCustomerNotValid={existingCustomerNotValid}
            userEnteredMobileNumber={userEnteredMobileNumber}
            setuserEnteredMobileNumber={setuserEnteredMobileNumber}
            masterDataEmail={masterDataEmail}
            masterDataName={masterDataName}
            masterDataIdValue={masterDataIdValue}
            masterDataTinValue={masterDataTinValue}
            masterDataFatherName={masterDataFatherName}
            masterDataMotherName={masterDataMotherName}
            masterDataHusbandName={masterDataHusbandName}
            masterDatahusbandWifeRadio={masterDatahusbandWifeRadio}
          />
        );
      case 1:
        return (
          <E_PremiseDetails
          districtdropdown={districtdropdown}
          setdistrictdropdown={setdistrictdropdown}
          thanadropdown={thanadropdown}
           setthanadropdown={setthanadropdown}
            sameAsPremiseCheck={sameAsPremiseCheck}
            setSameAsPremiseCheck={setSameAsPremiseCheck}
            setActiveStep={setActiveStep}
            handleClickOpen={handleClickOpen}
            divisionList={divisionList}
            setdivisionList={setdivisionList}
            districtPremise={districtPremise}
            address1Premise={address1Premise}
            address2Premise={address2Premise}
            postOfficePremise={postOfficePremise}
            divisionPremise={divisionPremise}
            divisionCodePremise={divisionCodePremise}
            postCodePremise={postCodePremise}
            thanaPremise={thanaPremise}
            districtMailing={districtMailing}
            address1Mailing={address1Mailing}
            address2Mailing={address2Mailing}
            postOfficeMailing={postOfficeMailing}
            divisionMailing={divisionMailing}
            postCodeMailing={postCodeMailing}
            thanaMailing={thanaMailing}
            setDistrictPremise={setDistrictPremise}
            setAddress1Premise={setAddress1Premise}
            setAddress2Premise={setAddress2Premise}
            setPostOfficePremise={setPostOfficePremise}
            setDivisionPremise={setDivisionPremise}
            setDivisionCodePremise={setDivisionCodePremise}
            setPostCodePremise={setPostCodePremise}
            setThanaPremise={setThanaPremise}
            setDistrictMailing={setDistrictMailing}
            setAddress1Mailing={setAddress1Mailing}
            setAddress2Mailing={setAddress2Mailing}
            setPostOfficeMailing={setPostOfficeMailing}
            setDivisionMailing={setDivisionMailing}
            setDivisionCodeMailing={setDivisionCodeMailing}
            setPostCodeMailing={setPostCodeMailing}
            setThanaMailing={setThanaMailing}
            checkBoxEnable={checkBoxEnable}
            connectionOnExistingPremise={connectionOnExistingPremise}
            setconnectionOnExistingPremise={setconnectionOnExistingPremise}
            premiseType={premiseType}
            setpremiseType={setpremiseType}
            premiseCategory={premiseCategory}
            setpremiseCategory={setpremiseCategory}
            setpremiseTypeCode={setpremiseTypeCode}
            setpremiseCategoryCode={setpremiseCategoryCode}
            showConnectionOnExistingPremise={showConnectionOnExistingPremise}
            setexistingPremiseID={setexistingPremiseID}
            existingPremiseValue={existingPremiseValue}
            setexistingPremiseValue={setexistingPremiseValue}
            existingPremisesList={existingPremisesList}
            sndCode={sndCode}
            setSndCode={setSndCode}
            sndValue={sndValue}
            setSndValue={setSndValue}
            existingCustomer={existingCustomer}
            masterDataAddress1Mailing={masterDataAddress1Mailing}
            masterDataAddress2Mailing={masterDataAddress2Mailing}
            masterDataPostOfficeMailing={masterDataPostOfficeMailing}
            masterDataPostCodeMailing={masterDataPostCodeMailing}
            masterDataDistrictMailing={masterDataDistrictMailing}
            masterDataDivisionCodeMailing={masterDataDivisionCodeMailing}
            masterDataDivisionMailing={masterDataDivisionMailing}
            masterDataThanaMailing={masterDataThanaMailing}
          />
        );
      case 2:
        return (
          <EUplaodDocuments
            termsAgreedTime={termsAgreedTime}
            setTermsAgreedTime={setTermsAgreedTime}
            handleClickOpen={handleClickOpen}
            name={name}
            connectionTypeCode={connectionTypeCode}
            connectionType={connectionType}
            setDocumentList={setDocumentList}
            documentList={documentList}
            documentCodeList={documentCodeList}
            setDropDownData={setDropDownData}
            dropDownData={dropDownData}
            idValue={idValue}
            setActiveStep={setActiveStep}
            existingCustomer={existingCustomer}

            masterDataIdValue={masterDataIdValue}
            masterDataName={masterDataName}
                      />
        )
    }
  }
  return (
    activeStep < 3 ? (<Grid className={classes.contentBg}>
      <Card className={classes.cardStyle} >
        <CardContent className={classes.cardCont}>
          <Grid >
            <EHeader activeStep={activeStep} setActiveStep={setActiveStep} handleClickOpen={handleClickOpen} />
          </Grid>
          <Grid >
            <EStepper activeStep={activeStep} />
          </Grid>
          <Grid className={classes.mainContentHeight}>
            {getPage()}
          </Grid>
        </CardContent>
      </Card>
      <EFooterSection />
      <Dialog onClose={handleClose} open={open} className={classes.dialogContainerStyling}>
        <Grid
          container
          alignItems="center"
          className={classes.contentColor}
          justify="space-between"
        >
          <Grid item xs={10}>
            <Typography variant="subtitle2">{summaryReviewLabel?.E_CONFIRMATION_LABEL}</Typography>
          </Grid>
          <Grid item xs={2} className={classes.rightIcon}>
            <IconButton aria-label="close" onClick={handleClose}>
              <Close className={classes.closeIcon} />
            </IconButton>
          </Grid>
        </Grid>
        <DialogContent dividers>
          <WarningRoundedIcon className={classes.alertIcon} />
          {
            contentReady ? <Typography className={[classes.detailsSubLine, classes.dialogTextPadding]}
              dangerouslySetInnerHTML={{
                __html: content("E_SUMMARY_REVIEW_CONFIRMATION").answer,
              }}
            >
            </Typography> : <Skeleton variant="text"></Skeleton>
          }

        </DialogContent>
        <DialogActions className={classes.dialoagActionPadding}>
          <Grid item xs={1} sm={1}>
            <Link component="button" onClick={() => { handleClose() }} underline="hover" className={classes.no}><Typography variant="button" >{summaryReviewLabel?.E_NO_LABEL}</Typography></Link>
          </Grid>
          <Grid item xs={3}>
            <Button
              className={classes.yes}
              size="small"
              align="right"
              onClick={backCall}
            >
              <Typography variant="button">{summaryReviewLabel?.E_YES_LABEL}</Typography>
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </Grid>) : (
      activeStep === 3 ? (
        <ESummaryReview
        noofconnections={noofconnections}
            name={name}
            fatherName={fatherName}
            husbandWifeRadio={husbandWifeRadio}
            husbandName={husbandName}
            motherName={motherName}
            email={email}
            mobile={mobile}
            idType={idType}
            idTypeCode={idTypeCode}
            idValue={idValue}
            tinTypeCode={tinTypeCode}
            tinValue={tinValue}
            dropDownData={dropDownData}
            individualVerifiedMobile={individualVerifiedMobile}
            tarrifType={tarrifType}
            tarrifTypeCode={tarrifTypeCode}
            Load={Load}
            meterType={meterType}
            meterTypeCode={meterTypeCode}
            idTypeOthers={idTypeOthers}
            isIndividualMobileVerified={isIndividualMobileVerified}
            existingCustomer={existingCustomer}
            existingCustomerID={existingCustomerID}
            connectionType={connectionType}
            connectionTypeCode={connectionTypeCode}
            sameAsPremiseCheck={sameAsPremiseCheck}
            handleClickOpen={handleClickOpen}
            districtPremise={districtPremise}
            address1Premise={address1Premise}
            address2Premise={address2Premise}
            postOfficePremise={postOfficePremise}
            divisionPremise={divisionPremise}
            divisionCodePremise={divisionCodePremise}
            postCodePremise={postCodePremise}
            thanaPremise={thanaPremise}
            districtMailing={districtMailing}
            address1Mailing={address1Mailing}
            address2Mailing={address2Mailing}
            postOfficeMailing={postOfficeMailing}
            divisionMailing={divisionMailing}
            divisionCodeMailing={divisionCodeMailing}
            postCodeMailing={postCodeMailing}
            thanaMailing={thanaMailing}
            checkBoxEnable={checkBoxEnable}
            connectionOnExistingPremise={connectionOnExistingPremise}
            premiseType={premiseType}
            premiseTypeCode={premiseTypeCode}
            premiseCategory={premiseCategory}
            premiseCategoryCode={premiseCategoryCode}
            termsAgreedTime={termsAgreedTime}
            documentList={documentList}
            setTicketNumber={setTicketNumber}
            setApplicationDate={setApplicationDate}
            setActiveStep={setActiveStep} 
            sndCode={sndCode}
            sndValue={sndValue}
            userEnteredMobileNumber={userEnteredMobileNumber}
            masterDataEmail={masterDataEmail}
            masterDataName={masterDataName}
            masterDataIdValue={masterDataIdValue}
            masterDataTinValue={masterDataTinValue}
            masterDataFatherName={masterDataFatherName}
            masterDataMotherName={masterDataMotherName}
            masterDataHusbandName={masterDataHusbandName}
            masterDatahusbandWifeRadio={masterDatahusbandWifeRadio}
            masterDataAddress1Mailing={masterDataAddress1Mailing}
            masterDataAddress2Mailing={masterDataAddress2Mailing}
            masterDataPostOfficeMailing={masterDataPostOfficeMailing}
            masterDataPostCodeMailing={masterDataPostCodeMailing}
            masterDataDistrictMailing={masterDataDistrictMailing}
            masterDataDivisionCodeMailing={masterDataDivisionCodeMailing}
            masterDataDivisionMailing={masterDataDivisionMailing}
            masterDataThanaMailing={masterDataThanaMailing}
        />
      ) : (
        <EConfirmation 
          ticketNo={ticketNumber}
          applicationDate={applicationDate}
          name={name}
          districtPremise={districtPremise}
          address1Premise={address1Premise}
          address2Premise={address2Premise}
          postOfficePremise={postOfficePremise}
          divisionPremise={divisionPremise}
          postCodePremise={postCodePremise}
          thanaPremise={thanaPremise}
          mobile={mobile}
          connectionType={connectionType}
          meterType={meterType}
          Load={Load}
          tarrifType={tarrifType}
         ></EConfirmation>
      )
    )
  )
}

export default ENewConnectionRequest